import {
  ServiceEntitlementActions,
  ServiceTierActions,
} from "../Constants/Constants";

/**
 * @param {*} data : response from get list of service entitlements api
 * @returns Array of objects as required by service entitlement table
 */
export const convertServiceEntitlementList = (data) => {
  const list = data?.serviceentitlements || [];
  return list.map((item) => {
    return {
      key: item.entitlementid,
      entitlementId: item.entitlementid,
      entitlementName: item.entitlementname,
      providerId: item.providerid,
      deviceModelId: item.devicemodelid,
      serviceTierId: item.servicetierid,
      providerName: item.providername,
      modelNumber: item.modelnumber,
      serviceTierName: item.servicetiername,
      profile: item.profile,
      profileDetails: item.profiledetails,
      volume: item.volume,
      status: item.entitlementstatus,
    };
  });
};

/**
 * @param {*} formData : service entitlement form submitted values
 * @param {*} action : action type: add or edit
 * @returns Object formatted as required by create or update api
 */
export const convertEntitlementFormToApiValues = (
  formData,
  action = ServiceEntitlementActions.add
) => {
  console.log("convertEntitlementFormToApiValues", formData);
  const returnData = {
    providerid: formData.providerId,
    devicemodelid: formData.deviceModelId,
    servicetierid: formData.serviceTierId,
    profile: formData.profile,
    volume: formData.volume,
  };
  if (action === ServiceTierActions.add) {
    returnData.entitlementname = formData.entitlementName;
  }
  if (action === ServiceTierActions.edit) {
    returnData.entitlementid = formData.entitlementId;
  }
  return returnData;
};
